import React from 'react';
import { Icon } from '../core/Icon.jsx';

/**
 * FilterChip — pill-shaped dropdown/filter trigger like the app's
 * "Mes: Octubre ▾" and "Estado: Todos" chips.
 */
export function FilterChip({ label, value, icon = 'chevron-down', active = false, style = {}, ...rest }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        height: 48,
        padding: '0 16px',
        background: active ? 'var(--brand-green-soft)' : 'var(--input-bg)',
        border: `1px solid ${active ? 'var(--primary)' : 'var(--border)'}`,
        borderRadius: 'var(--radius)',
        color: 'var(--text-body)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-body)',
        fontWeight: 'var(--fw-semibold)',
        cursor: 'pointer',
        filter: hover ? 'brightness(1.1)' : 'none',
        transition: 'filter .15s ease',
        ...style,
      }}
      {...rest}
    >
      {label && <span style={{ color: 'var(--text-faint)' }}>{label}</span>}
      <span>{value}</span>
      {icon ? <Icon name={icon} size={18} color="var(--text-faint)" /> : null}
    </button>
  );
}
